<template>
    <div>
        <slot v-bind="{ isActive }"></slot>
    </div>
</template>

<script>
    export default {
        props: {
            keys: {
                required: true,
                type: Array,
            },
        },

        data() {
            return {
                active: 0,
                interval: null,
            };
        },

        mounted() {
            this.interval = setInterval(() => {
                this.active = (this.active + 1) % this.keys.length;
            }, 10000);
        },

        beforeDestroy() {
            clearInterval(this.interval);
        },

        methods: {
            isActive(key) {
                return key === this.keys[this.active];
            },
        },
    };
</script>
